import React from 'react'
import {
  CheckOutlined,
  CloseOutlined,
  ExclamationOutlined,
} from '@ant-design/icons'
import { IRefuelResult } from './types'
import { MIN_LITERS } from './constants'
import { formatLiters } from './format'

interface IFResultStep {
  result: IRefuelResult
  account: string
  /** False once the attempt cap is spent, which hides «Повторити». */
  canRetry: boolean
}

/*
    The server's Error text is what the user reads — minus the status/error
    pair the backend writes into it, which readMessage strips before the text
    reaches here. Most of these messages are two sentences — «Сервіс тимчасово
    недоступний. АЗК не відповідає (…)» — so the first one becomes the heading
    and the rest the body. Nothing else is reworded or dropped.
 */
const splitMessage = (text: string): [string, string] => {
  const end = text.indexOf('. ')
  return end === -1
    ? [text, '']
    : [text.slice(0, end + 1), text.slice(end + 2).trim()]
}

const ACTION_HINTS: { [action: string]: string } = {
  retry: 'Спробуйте ще раз за кілька секунд.',
  amount: `Змініть кількість — мінімум ${MIN_LITERS} л.`,
  params: 'Змініть параметри заправки та спробуйте ще раз.',
  station: 'Оберіть іншу АЗК.',
}

const ResultStep: React.FC<IFResultStep> = (props) => {
  const { result, canRetry } = props

  if (result.ok) {
    return (
      <div className="refuel-status">
        <div className="refuel-status__icon success">
          <CheckOutlined />
        </div>
        <div className="refuel-status__title">Заправку розпочато</div>
        <div className="refuel-status__text">
          {`Колонка №${result.dispenser}, ${result.fuelName}, `}
          {`${formatLiters(result.amount)} л. ${props.account}`}
        </div>
      </div>
    )
  }

  const [head, rest] = splitMessage(result.message)
  const hint = ACTION_HINTS[result.action]
  const warn = result.action !== 'retry'

  return (
    <div className="refuel-status">
      <div className={warn ? 'refuel-status__icon warn' : 'refuel-status__icon fail'}>
        {warn ? <ExclamationOutlined /> : <CloseOutlined />}
      </div>
      <div className="refuel-status__title">{head}</div>
      <div className="refuel-status__text">
        {rest}
        {rest && hint ? ' ' : ''}
        {hint}
        {result.status === 1 && result.error === 17 && (
          <>
            {' '}
            Не надсилайте замовлення повторно — зачекайте й перевірте баланс.
          </>
        )}
      </div>
      {result.action === 'retry' && !canRetry && (
        <div className="refuel-status__note">
          Спроби вичерпано. Перевірте баланс перед новим замовленням.
        </div>
      )}
    </div>
  )
}

export default ResultStep
